import React from 'react';
import { Button, Text } from '@chakra-ui/react';
import '../../Styles/theme/PasswordModel.css';

const ConfirmDeleteModal = ({
  visible,
  title,
  isLoading,
  onConfirm,
  onCancel
}) => {
  if (!visible) return null;
  
  return (
    <div className="model-overlay">
      <div className="model" style={{ maxWidth: '400px', textAlign: 'center' }}>
        <Text fontSize="lg" mb={4}>{title || '確定要刪除嗎？此操作無法復原。'}</Text>
        <div className="button-group">
          <Button 
            colorScheme="red" 
            mr={3} 
            onClick={onConfirm}
            isLoading={isLoading}
          >
            確定刪除
          </Button>
          <Button variant="outline" onClick={onCancel}>取消</Button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDeleteModal;
